import { render, staticRenderFns } from "./AgencySettings.vue?vue&type=template&id=54e2256a&scoped=true&"
import script from "./AgencySettings.vue?vue&type=script&lang=ts&"
export * from "./AgencySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2256a",
  null
  
)

export default component.exports